"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

exports["default"] = function (source, panelSize) {
  var bg = source;
  var bgStyle = {};
  if (bg === undefined) return bgStyle;

  //size
  if (!!bg.size) {
    if (panelSize !== undefined && (bg.size === "leftHalf" || bg.size === "rightHalf")) {
      bgStyle.backgroundSize = panelSize.width * 2 + "px " + panelSize.height + "px";
      bgStyle.backgroundPosition = bg.size === "leftHalf" ? '0% 0%' : '100% 0%';
      //console.log(bgStyle);
    } else {
        bgStyle.backgroundSize = bg.size;
        if (!!bg.position) bgStyle.backgroundPosition = bg.position;
      }
  }
  //gradient
  var bgGradient = bg.gradient;
  if (bgGradient !== undefined) {
    //gradient
    if (bgGradient.stops !== undefined) {
      var gradientStops = _lodash2["default"].reduce(bgGradient.stops, function (memo, stop) {
        return memo + ', ' + stop.color + ' ' + stop.offset * 100 + '%';
      }, '');

      var orientation = bgGradient.orientation || 'top';
      var grandientType = bgGradient.orientation === 'center, ellipse cover' ? '-webkit-radial-gradient' : '-webkit-linear-gradient';
      bgStyle.background = grandientType + '(' + orientation + gradientStops + ')';
    }
  }

  //color
  var bgColor = bg.color;
  if (bgColor !== undefined) {
    if (!!bgColor.color) bgStyle.backgroundColor = bgColor.color;
    if (!!bgColor.alpha) bgStyle.opacity = bgColor.alpha / 100;
  }

  if (!!bg.image) bgStyle.backgroundImage = 'url(' + bg.image + ')';
  if (!!bg.repeat) bgStyle.backgroundRepeat = bg.repeat;
  if (!!bg.attachment) bgStyle.backgroundAttachment = bg.attachment;

  var filter = bg.filter || {};
  var cssFilter = "";
  if (!!filter.blur) cssFilter += ' blur(' + filter.blur + 'px)';
  if (!!filter.brightness) cssFilter += ' brightness(' + filter.brightness + '%)';
  if (!!filter.contrast) cssFilter += ' contrast(' + filter.contrast + '%)';
  if (!!filter.grayscale) cssFilter += ' grayscale(' + filter.grayscale + '%)';
  if (!!filter.hueRotate) cssFilter += ' hue-rotate(' + filter.hueRotate + 'deg)';
  if (!!filter.invert) cssFilter += ' invert(' + filter.invert + '%)';
  if (!!filter.opacity) cssFilter += ' opacity(' + filter.opacity + '%)';
  if (!!filter.saturate) cssFilter += ' saturate(' + filter.saturate + '%)';
  if (!!filter.sepia) cssFilter += ' sepia(' + filter.sepia + '%)';

  if (!!cssFilter) {
    bgStyle.WebkitFilter = cssFilter;
    bgStyle.filter = cssFilter;
  }
  //bgStyle.position = 'absolute';
  return bgStyle;
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-designer-core/lib/util/backgroundStyle.js
 ** module id = 1122
 ** module chunks = 0
 **/